module.exports = __webpack_public_path__ + "img/paint-slice_03.e3bf6e3d.jpg";